import React, { useState } from "react";
import Header from "../../../../components/Header";
import LeftMenu from "../../../../components/LeftMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faUser,
  faChair,
  faCouch,
  faTimes
} from "@fortawesome/free-solid-svg-icons";

import MoveLocationHeader from "./components/MoveLocationHeader";
import MoveEntitySection from "./components/MoveEntitySection";


export default function MovesEdit() {

 
	const peopleColumns = [
	  { key: "name", label: "Name" },
	  { key: "department", label: "Department" },
	  { key: "deskCode", label: "Desk" },
	  { key: "status", label: "Status", type: "status" }
	];
	
	const movePeople = [
	  {
	    id: 1,
	    name: "Jane Smith",
	    department: "Finance",
	    deskCode: "RF.08.M12.06",
	    status: "Assigned"
	  },
	  {
	    id: 2,
	    name: "Mark Thompson",
	    department: "IT",
	    deskCode: "RF.08.M10.03",
	    status: "Assigned"
	  },
	  {
	    id: 3,
	    name: "David Patel",
	    department: "Operations",
	    deskCode: "RF.08.N11.10",
	    status: "Assigned"
	  }
	];
	
	const availablePeople = [
	  {
	    id: 4,
	    name: "Sarah Collins",
	    department: "HR",
	    deskCode: null,
	    status: "Unallocated"
	  },
	  {
	    id: 5,
	    name: "Emma Wright",
	    department: "Marketing",
	    deskCode: "RF.08.N12.05",
	    status: "Assigned"
	  },
	  {
	    id: 6,
	    name: "Tom Reynolds",
	    department: "IT",
	    deskCode: null,
	    status: "Pending"
	  },
	  {
	    id: 7,
	    name: "Lucy Bennett",
	    department: "Legal",
	    deskCode: "RF.08.K10.01",
	    status: "Assigned"
	  }
	];
	
	function addPeopleToMove(selectedIds) {

	  console.log("Adding people IDs:", selectedIds);

	  var selectedPeople = availablePeople.filter(function (p) {
	    return selectedIds.indexOf(p.id) !== -1;
	  });

	  // In real life:
	  // - call API
	  // - update state from response

	  console.log("Selected people:", selectedPeople);
	}





  return (
    <div style={{ marginLeft: "60px", marginTop: "70px", width:'calc(100% - 60px)', flexDirection:'column' }}>
      <Header />
      <LeftMenu />
		<MoveLocationHeader
			origin="Regional Office"
			destination="London HQ"
			status="In Progress"
			deskCount={30}
			peopleCount={25}
			boxCount={455}
		/>	  
		<MoveEntitySection
		  title="People"
		  columns={peopleColumns}
		  rows={movePeople}
		  availableRows={availablePeople}
		  onAddEntities={addPeopleToMove}
		/>

    </div>
  );
}
